import { render, staticRenderFns } from "./WinAMiniGameList.vue?vue&type=template&id=34ebee9f"
import script from "./WinAMiniGameList.vue?vue&type=script&lang=js"
export * from "./WinAMiniGameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports